module.exports = __webpack_public_path__ + "img/pulido_tipo_yeso.5275988c.png";